
import axios from "axios";
// import { showToast } from "vant";irm https://raw.githubusercontent.com/yuaotian/go-cursor-help/master/scripts/install.ps1 | iex

const instance = axios.create({
  // baseURL: "http://127.0.0.1:3000",
  // baseURL: "http://172.30.33.87:3000",
  baseURL: 'http://182.92.155.149:3000',
  timeout: 10000,
  withCredentials: false,
});

// 请求拦截器，用于在请求发送前做一些处理
instance.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么
    // config.headers['Content-Type'] = 'application/json'; // 关键设置
    config.headers['authorization'] = 'Bearer' + ' ' + localStorage.getItem('token');
    // console.log('config.data',config.data)
    // console.log(`[Request] ${config.method.toUpperCase()} ${config.url}`);
    // 可以添加其他请求相关的日志，例如请求头、请求体等
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    console.error(`[Request Error] ${error}`);
    return Promise.reject(error);
  }
);

// 响应拦截器
// instance.interceptors.response.use(
//   (response) => {
//     // 对2xx范围内的状态码都会触发该函数
//     const { data, config } = response;
//     console.log(data,config)
    
//     // 记录成功日志
//     console.log(`[Response] ${config.method.toUpperCase()} ${config.url}`, {
//       status: response.status,
//       data: data
//     });

//     // 根据后端数据格式处理，这里假设直接返回数据体
//     // 如果后端有封装结构，例如 { code: 200, data: {}, message: 'success' }
//     // 可以在这里统一处理：
//     if (data.code && data.code !== 200) {
//       return Promise.reject(data);
//     }
    
//     return data;
//   },
//   (error) => {
//     // 超出2xx范围的状态码都会触发该函数
//     const { response, config } = error;
    
//     // 请求已发出但服务器未响应
//     if (!response) {
//       console.error('[Network Error]', error.message);
//       return Promise.reject({
//         code: -1,
//         message: '网络连接异常，请检查网络设置'
//       });
//     }

//     // 记录错误日志
//     console.error(`[Response Error] ${config?.method?.toUpperCase() || ''} ${config?.url || ''}`, {
//       status: response.status,
//       data: response.data
//     });

//     // 根据HTTP状态码处理
//     const { status, data } = response;
//     switch (status) {
//       case 401: // 未授权
//         // 清除无效token
//         localStorage.removeItem('token');
//         // 跳转到登录页
//         // window.location.href = '/';
//         return Promise.reject({
//           code: 401,
//           message: data?.message || '登录已过期，请重新登录'
//         });

//       case 403: // 禁止访问
//         return Promise.reject({
//           code: 403,
//           message: data?.message || '没有访问权限'
//         });

//       case 404: // 资源不存在
//         return Promise.reject({
//           code: 404,
//           message: data?.message || '请求资源不存在'
//         });

//       case 500: // 服务器错误
//         return Promise.reject({
//           code: 500,
//           message: data?.message || '服务器开小差了，请稍后再试'
//         });

//       default:
//         return Promise.reject({
//           code: status,
//           message: data?.message || `请求错误 (${status})`
//         });
//     }
//   }
// );
// 添加响应拦截器
// instance.interceptors.response.use(
//   function (response) {
//     // 对响应数据做点什么
//     // 例如，这里我们简单地将响应数据返回
//     console.log(response)
//     return response;
//   },
//   function (error) {
//     // 对响应错误做点什么
//     // 例如，这里我们打印错误信息并返回Promise.reject
//     console.log('Error:', error);
//     return Promise.reject(error);
//   }
// );

// // 响应拦截器，用于对响应数据做点什么
// instance.interceptors.response.use(
//     function (response) {
//       console.log(response)
//       const data = response.data;
//       if (data.errcode !== "0") {
//         showToast("请求错误")
//       }
//       return data;
//     },
//     function (error) {
//       if (error.response.status == 400) {
//         showToast("请求错误")
//       } else if (error.response.status == 401) {
//         showToast("过期请重新登录！");
//       } else if (error.response.status == 404) {
//         showToast("过期请重新登录！");
//       } else if (error.response.status == 408) {
//         showToast("过期请重新登录！");
//       } else if (error.response.status == 500) {
//         const {message} = error.response.data;
//         if (message == "402,token过期请重新登录！") {
//           showToast("过期请重新登录！");
//           // router.replace({path: "/login"})
//           return null
//         }
//         if (message == "401") {
//           window.vm.$message.error('登录已过期，请重新登录')
//           // router.replace({path: "/login"})
//           return null
//         }
//         window.vm.$message.error({message: "服务器内部错误", showClose: true})
//       } else if (error.response.status == 501) {
//         window.vm.$message.error({message: "服务未实现", showClose: true})
//       } else if (error.response.status == 502) {
//         window.vm.$message.error({message: "网关错误", showClose: true})
//       } else if (error.response.status == 503) {
//         window.vm.$message.error({message: "服务不可用", showClose: true})
//       } else if (error.response.status == 504) {
//         window.vm.$message.error({message: "网关超时", showClose: true})
//       } else if (error.response.status == 505) {
//         window.vm.$message.error({message: "HTTP版本不受支持", showClose: true})
//       }
//       const response = {
//         data: {success: false, respData: {}}
//       }
//       return response;
//     }
//   );

export default instance;
// import axios from "axios";


// let config = {
//   baseURL: 'http://172.30.33.227:3000',
//   // baseURL: 'http://47.96.72.39:3000',
//   timeout: 4000,
//   withCredentials: false // 这个参数表示在跨域请求时是否需要使用凭证，默认是 false。
// };
// const instance = axios.create(config);

// // 请求拦截器
// instance.interceptors.request.use(
//   function (config) {

//     // 设置请求头等操作
//     config.headers['authorization'] = 'Bearer' + ' ' + localStorage.getItem('token');

//     return config;
//   },
//   function (error) {
//     return Promise.reject(error);
//   }
// );
// // 响应拦截器，用于对响应数据做点什么
// instance.interceptors.response.use(
//   (response) => {
//     // 对响应数据做点什么
//     console.log(`[Response] ${response.status} ${response.config.url}`);
//     // 可以添加其他响应相关的日志，例如响应体、响应头等
//     return response;
//   },
//   (error) => {
//     // 对响应错误做点什么
//     if (error.response) {
//       // 请求已发出，服务器也响应了状态码，但状态码不在 2xx 范围内
//       console.error(
//         `[Response Error] ${error.response.status} ${error.response.config.url}`
//       );
//     } else if (error.request) {
//       // 请求已发出，但没有收到任何响应
//       console.error(`[Request Timeout] ${error.request}`);
//     } else {
//       // 发送请求时发生了某些事情，导致请求没有发送出去
//       console.error(`[Error] ${error.message}`);
//     }
//     return Promise.reject(error);
//   }
// );
// instance.interceptors.response.use(
//   function (response) {
//     const data = response.data;
//     if (data.errcode !== "0") {
//       window.vm.$message.error({message: data.errmsg, showClose: true})
//     }
//     return data;
//   },
//   function (error) {
//     if (error.response.status == 400) {
//       window.vm.$message.error({message: "请求错误", showClose: true})
//     } else if (error.response.status == 401) {
//       window.vm.$message.error({message: "未授权，请登录", showClose: true})
//     } else if (error.response.status == 404) {
//       window.vm.$message.error({message: "请求地址出错", showClose: true})
//     } else if (error.response.status == 408) {
//       window.vm.$message.error({message: "请求超时", showClose: true})
//     } else if (error.response.status == 500) {
//       const {message} = error.response.data;
//       if (message == "402,token过期请重新登录！") {
//         window.vm.$message.error('登录已过期，请重新登录')
//         // router.replace({path: "/login"})
//         return null
//       }
//       if (message == "401") {
//         window.vm.$message.error('登录已过期，请重新登录')
//         // router.replace({path: "/login"})
//         return null
//       }
//       window.vm.$message.error({message: "服务器内部错误", showClose: true})
//     } else if (error.response.status == 501) {
//       window.vm.$message.error({message: "服务未实现", showClose: true})
//     } else if (error.response.status == 502) {
//       window.vm.$message.error({message: "网关错误", showClose: true})
//     } else if (error.response.status == 503) {
//       window.vm.$message.error({message: "服务不可用", showClose: true})
//     } else if (error.response.status == 504) {
//       window.vm.$message.error({message: "网关超时", showClose: true})
//     } else if (error.response.status == 505) {
//       window.vm.$message.error({message: "HTTP版本不受支持", showClose: true})
//     }
//     const response = {
//       data: {success: false, respData: {}}
//     }
//     return response;
//   }
// );

// export default instance
